import styled, { css } from 'styled-components';
import { IconBoxProps } from './IconBox.types';

export const IconBox = styled.div<IconBoxProps>`
  background-image: ${({ $filename }) => `url(/images/${$filename})`};
  width: ${({ $width }) => $width ?? 20}px;
  min-width: ${({ $width }) => $width ?? 20}px;
  height: ${({ $height }) => $height ?? 20}px;
  background-position: center;
  background-size: ${({ $iconWidth, $iconHeight }) =>
    `${$iconWidth ? `${$iconWidth}px` : 'auto'} ${
      $iconHeight ? `${$iconHeight}px` : 'auto'
    }`};
  background-repeat: no-repeat;

  ${({ $isMirroredX }) =>
    $isMirroredX &&
    css`
      transform: scaleX(-1);
    `}
`;
